import React from 'react';
// import workload1 from '@assets/svg/icons/workload1.svg';

const FixedInVersion = ({ data }) => {
  // console.log(data, 'fixed_in_versionfixed_in_version');

  if (!data) {
    return <p>No data available</p>;
  }

  return (
    <div
      style={{
        // width: '100%',
        backgroundColor: 'rgb(219, 234, 254)',
        borderRadius: '10px',
        marginBottom: '16px',
        padding: '7px 11px 7px 11px',
        marginRight: '0.7rem',
      }}>
      <p
        style={{
          color: '#1A202C',
          fontSize: '12px',
          fontWeight: 500,
          margin: '0',
          // lineHeight: '19.12px',
        }}>
        {data || 'No fixed_in_version available'}
      </p>
    </div>
  );
};

export default FixedInVersion;
